export const DEFAULT_SETTINGS = {
  phone: "06 00 00 00 00",
  email: "contact@mary-services.com",
  zone: "Zone d'intervention à définir",
  hero_kicker: "Dedans, dehors, c'est fait.",
  hero_title: "Un seul contact. Plusieurs savoir-faire.",
  hero_subtitle: "Entretien extérieur · Nettoyage · Petits travaux · Remise en état",
  hero_tagline: "Une équipe polyvalente pour vos besoins du quotidien.",
  hero_cta: "Demander un devis",
  hero_photo_before: "",
  hero_photo_before_alt: "Intervention MARY SERVICES — avant",
  hero_photo_after: "",
  hero_photo_after_alt: "Intervention MARY SERVICES — après",
  hero_photo_main: "",
  hero_photo_main_label: "Remise en état",
  hero_photo_main_position: "centre",
  hero_photo_main_alt: "Intervention MARY SERVICES — extérieur remis en état",
  hero_photo_mobile: "",
  hero_photo_mobile_position: "centre",
  hero_photo_mobile_alt: "Intervention MARY SERVICES",
  hero_photo_secondary: "",
  hero_photo_secondary_label: "",
  hero_photo_secondary_position: "centre",
  hero_photo_mobile_enabled: "false",
  facebook: "",
  instagram: "",
};

export const QUOTE_STATUSES = [
  { key: "nouveau", label: "Nouveau", cls: "bg-sky-100 text-sky-800" },
  { key: "a_contacter", label: "À contacter", cls: "bg-amber-100 text-amber-800" },
  { key: "en_cours", label: "En cours", cls: "bg-blue-100 text-blue-800" },
  { key: "devis_envoye", label: "Devis envoyé", cls: "bg-violet-100 text-violet-800" },
  { key: "accepte", label: "Accepté", cls: "bg-green-100 text-green-800" },
  { key: "refuse", label: "Refusé", cls: "bg-red-100 text-red-800" },
  { key: "termine", label: "Terminé", cls: "bg-neutral-200 text-neutral-700" },
];

export const statusOf = (k) => QUOTE_STATUSES.find((s) => s.key === k) || QUOTE_STATUSES[0];

export const CATEGORIES = [
  "Débroussaillage",
  "Taille de haie",
  "Tonte",
  "Élagage",
  "Nettoyage",
  "Remise en état",
  "Entretien extérieur",
  "Autre",
];

export const NEED_TYPES = [
  "Entretien des espaces verts",
  "Élagage & entretien extérieur",
  "Nettoyage extérieur",
  "Remise en état",
  "Entretien régulier (contrat)",
  "Autre / sur mesure",
];

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
  } catch {
    return iso;
  }
};
